import React, { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import InvoiceItems from "./InvoiceItems";
import { FaFilePdf } from "react-icons/fa6";
import { ConvertPriceToString } from "../../../Helpers/CustomConverter";
import { useInvoices } from "../../../Providers/InvoicesProvider";
import useDownloadFinanceDocuments from "../../../Hooks/useDownloadFinanceDocuments";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { formatDocumentNumber } from "../../../Helpers/DocumNumHelper";
import { useAuth } from "../../../Providers/AuthProvider";
import { useParams } from "../../../Providers/ParamsProvider";
import { Licenses } from "../../../Data/Licenses.ts";

const Invoice = ({ invoice, setShowNoEInvoiceModal }) => {
  const { authState } = useAuth()
  const [ordersValue, setOrdersValue] = useState(0);
  const { handleGetArchiveInvoiceItems } = useInvoices();
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [showItems, setShowItems] = useState(false);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const { downloadFinanceDocument, isLoading } = useDownloadFinanceDocuments();
  const { license } = useParams();
  function reverseDate(date) {
    const [year, month, day] = date.split('-')
    return `${day}-${month}-${year}`
  }

  function reverseDateShort(date) {
    return `${date.substring(4, 6)}-${date.substring(2, 4)}-20${date.substring(0, 2)}`
  }

  function countPayDays() {
    const docDateToCompare = new Date(invoice.docDate);
    const payDateToCompare = new Date('20' + invoice.paidDate.substring(0, 2) + '-' + invoice.paidDate.substring(2, 4) + '-' + invoice.paidDate.substring(4, 6));

    const differenceInTime = new Date(payDateToCompare.getFullYear(), payDateToCompare.getMonth(), payDateToCompare.getDate()) - new Date(docDateToCompare.getFullYear(), docDateToCompare.getMonth(), docDateToCompare.getDate()); // Wynik w milisekundach
    const differenceInDays = Math.round(differenceInTime / (1000 * 60 * 60 * 24)); // Przeliczenie na dni

    return differenceInDays - invoice.payTerm;
  }

  useEffect(() => {
    if (showItems) {
      handleGetItems()
    }
  }, [showItems])

  const handleGetItems = async () => {
    setIsLoadingItems(true)
    const items = await handleGetArchiveInvoiceItems(invoice)
    setInvoiceItems(items)
    setIsLoadingItems(false)
  }

  const handleDownloadPdf = () => {
    if ((authState.user && authState.user.customerInfo && authState.user.customerInfo[0].isEInvoiceConsent) || (authState.user && authState.user.isOperator)) {
      downloadFinanceDocument(invoice.nrDoc, invoice.docDate, invoice.oddzial)
      return
    }
    else {
      setShowNoEInvoiceModal(true)
    }
  }

  return (
    <>
      <tr className="hoverable-row">
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{license == Licenses.TgInstalacje ? invoice.seller.toLocaleLowerCase().replace('tg instalacje sp. z o.o. ', '').toLocaleUpperCase() : invoice.seller}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{invoice.docName}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{formatDocumentNumber(invoice.nrDoc, invoice.docDate, invoice.oddzial)}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
          {reverseDate(invoice.docDate.substring(0, invoice.docDate.indexOf("T")))}
        </td>
        <td style={{ alignContent: "center", textAlign: "left", fontSize: '14px', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
          {ConvertPriceToString(invoice.value, null)}
        </td>
        <td style={{ alignContent: "center", textAlign: 'left', fontSize: '14px', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
          {ConvertPriceToString(invoice.paid, null)}
        </td>
        <td style={{ alignContent: "center", textAlign: 'left', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
          {invoice.paidDate.toString().trim().length > 0 && reverseDateShort(invoice.paidDate)}
        </td>
        <td style={{ alignContent: "center", textAlign: 'left', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
          {invoice.value - invoice.paid == 0 || -invoice.value - invoice.paid == 0 ? countPayDays() : ''}
        </td>
        <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
          {invoice.comments}
        </td>
        <td style={{ alignContent: "center", textAlign: "center" }}>
          {isLoading ? <LoadingSpinner width={2} height={2} bubble={false} /> : <FaFilePdf style={{ cursor: "pointer" }} color="black" size={20} onClick={() => handleDownloadPdf()} />}
        </td>
      </tr>
      {showItems && (
        <tr>
          <td colSpan="8" style={{ padding: 10 }}>
            <InvoiceItems items={invoiceItems} isLoading={isLoadingItems} />
          </td>
        </tr>
      )}
    </>
  );
};

export default Invoice;
